/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-05 12:06:20
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-08-04 15:50:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/common.ts
 */

import {
  EnumScrollType,
  EnumCarouselOptions,
  EnumModuleType,
  EnumSeoTag,
} from 'src/types/common/module';

import { EnumLinkType } from 'src/types/common/linkType';

import {
  useErrorOnChange,
  generateProductList,
  generateProductGrid,
  generateText,
  generateLongCanvas,
  generatePoster,
  generateCarousel,
  generateProductCarousel,
  generateLinkImg,
  ProductCarouselAmountOptions,
  PostOptions,
  ProductCarouselScrollOptions,
  staticModuleType,
  optionsToNum,
  CarouselOptions,
  hasItemList,
  GridOptions,
  SeoTag,
  listPropertyName,
  moduleHeaderProperties,
  generateSubscription,
  generateVideo,
} from 'src/constrains/DraggableModules/tools';
//=============================================//

enum EnumQuery {
  isNew = 'isNew',
  hasErrorCollapse = 'hasErrorCollapse',
}
interface IParams {
  contentUuid: string;
  saleChannelUuid: string;
  contentPageUuid: string;
}

export {
  useErrorOnChange,
  generateProductList,
  generateProductGrid,
  generateText,
  generateLongCanvas,
  generatePoster,
  generateCarousel,
  generateProductCarousel,
  generateLinkImg,
  IParams,
  EnumQuery,
  ProductCarouselAmountOptions,
  PostOptions,
  ProductCarouselScrollOptions,
  staticModuleType,
  optionsToNum,
  CarouselOptions,
  hasItemList,
  GridOptions,
  SeoTag,
  listPropertyName,
  EnumSeoTag,
  EnumScrollType,
  EnumCarouselOptions,
  EnumModuleType,
  EnumLinkType,
  moduleHeaderProperties,
  generateSubscription,
  generateVideo,
};
